import React from "react";
import { Link } from "react-router-dom";
const Home = () => {
  return (
    <div style={{ height: "100vh", padding: "20px", backgroundColor: "#232323", color: "white" }}>
      <h1 style={{ fontSize: "48px", marginBottom: "20px" }}>Homepage</h1>
      <p style={{ fontSize: "18px", marginBottom: "30px" }}>
        This project was generated By{" "}
        <a href="https://www.dhiwise.com" style={{ color: "#87CEFA", textDecoration: "none" }}>
          Dhiwise
        </a>
        . Quickly use below links to navigate through all pages.
      </p>
      <ul style={{ listStyle: "none", padding: "0" }}>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/home1" style={{ color: "#87CEFA", textDecoration: "none" }}>
            Home1
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/solutions" style={{ color: "#87CEFA", textDecoration: "none" }}>
            Solutions
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/aboutus" style={{ color: "#87CEFA", textDecoration: "none" }}>
            Aboutus
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/blogs" style={{ color: "#87CEFA", textDecoration: "none" }}>
            Blogs
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/casestudies" style={{ color: "#87CEFA", textDecoration: "none" }}>
            CaseStudies
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/career" style={{ color: "#87CEFA", textDecoration: "none" }}>
            Career
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/contactus" style={{ color: "#87CEFA", textDecoration: "none" }}>
            ContactUs
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/bookademo" style={{ color: "#87CEFA", textDecoration: "none" }}>
            Bookademo
          </Link>
        </li>
        <li style={{ marginBottom: "10px" }}>
          <Link to="/blogsinternal" style={{ color: "#87CEFA", textDecoration: "none" }}>
            BlogsInternal
          </Link>
        </li>
      </ul>
    </div>
  );
};
export default Home;
